import * as Yup from 'yup';
import { BasinEnterpriseIdentifier } from '../../models/water-usage-place';
import { WaterManagementDecisionPart } from '../../models/water-management-decision-part';

export function useValidationSchema() {
  return Yup.object<WaterManagementDecisionPart>().shape({
    ppId: Yup.object<BasinEnterpriseIdentifier>().shape({
      id: Yup.string().nullable().required('Povinné pole'),
      enterprise: Yup.string().nullable().required('Povinné pole'),
    }),
    ispopId: Yup.string().nullable().required('Povinné pole'),
  });
}
